<script setup>
import { defineProps } from 'vue'
const props = defineProps(['title', 'subTitle', 'textColor', 'top', 'bottom'])
</script>

<template>
  <div
    class="w-full flex flex-wrap"
    :style="{
      marginTop: top,
      marginBottom: bottom,
      color: textColor || '#333333',
    }"
  >
    <div class="w-full text-[36px] leading-[40px] font-bold text-center">
      {{ props?.title }}
    </div>
    <div
      class="w-full text-[24px] leading-[32px] font-medium text-center text-[#666666] mt-3 px-8 subTitle"
    >
      {{ props?.subTitle }}
    </div>
  </div>
</template>

<style scoped>
.subTitle{
  white-space: pre-line !important;
}
</style>
